module.exports = __webpack_public_path__ + "tj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tj.svg
// module id = 839
// module chunks = 0